import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
@Component({
  selector: "app-medium-cta",
  templateUrl: "./medium-cta.component.html",
  styleUrls: ["./medium-cta.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediumCtaComponent {
  @Input() property1:
    | "Primary CTA_Large_Active"
    | "Primary CTA_Large_Disable"
    | "Secondary CTA_Large_Active"
    | "Secondary CTA_Large_Disable" = "Primary CTA_Large_Active";
}
